import { createEffect, createSignal, type JSX, on } from 'solid-js';
import { t } from '../i18n';
import { lockedSeconds, usePageGuard } from '../lib/flood-guard-context';

// The Fleet page's ONE announcement of the controls lock (#6753): when the page's flood guard
// locks, "Too many changes in a row. Controls unlock in <n> s." once, and when it lifts,
// "Controls unlocked". Each card shows the counting line (`ControlLock`) without a live
// region, so a page of cards is not read out once per card, and never once per second.

export function ControlLockStatus(): JSX.Element {
  const page = usePageGuard();
  const [said, setSaid] = createSignal('');
  const locked = (): boolean => page !== null && lockedSeconds(page) > 0;
  createEffect(
    on(
      locked,
      (now) => {
        if (page === null) return;
        setSaid(
          now
            ? t('fleet.machines.ctl_locked', { n: page.guard.lockedSeconds() })
            : t('fleet.machines.ctl_unlocked_live'),
        );
      },
      { defer: true },
    ),
  );
  return (
    <p class="sr-only" role="status">
      {said()}
    </p>
  );
}
